import {t} from '@lingui/core/macro';

import {TAG_LABEL_MAX} from 'shared/lib/constants';

const ALLOWED_CHARS_PATTERN = /^[\p{L}\p{N}_-]+$/u;

export function extractTagBody(value: string): string {
    const label = (value ?? '').trim();

    return label.startsWith('#') ? label.slice(1) : label;
}

export function validateTagLabel(value: string): string | true {
    const body = extractTagBody(value);

    if (body === '') {
        return t`Введите название тега`;
    }

    if (body.length > TAG_LABEL_MAX) {
        return t`Максимальная длина тега - ${TAG_LABEL_MAX} символов`;
    }

    if (!ALLOWED_CHARS_PATTERN.test(body)) {
        return t`В теге можно использовать только буквы, цифры, дефис и подчёркивание`;
    }

    return true;
}
